import React, { useState } from 'react';
import dayjs from 'dayjs';
import block from 'bem-cn';
import { useSelector, shallowEqual } from 'react-redux';

import Input from 'components/Input';
import InputDate from 'components/InputDate';
import Button from 'components/Button';

import plusIcon from './img/plus.svg';
import minusIcon from './img/minus.svg';

import './FiltersPanel.scss';
import SVG from 'components/SVG';

const b = block('filters-panel');

const FiltersPanel = ({ onSubmitFilters }) => {
  const [open, setOpen] = useState(true);
  const [requestId, setRequestId] = useState('');
  const [loginValue, setLoginValue] = useState('');
  const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'month').toDate());
  const [toDate, setToDate] = useState(new Date());

  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const toggleFilters = () => setOpen(prev => !prev);

  const handleSubmit = e => {
    e.preventDefault();

    const filters = {
      cashier_withdrawal_id: requestId || undefined,
      login: loginValue || undefined,
      date_from: fromDate ? dayjs(fromDate).format('YYYY-MM-DD HH:mm') : undefined,
      date_to: toDate ? dayjs(toDate).format('YYYY-MM-DD HH:mm') : undefined,
    };

    onSubmitFilters(filters);
  };

  return (
    <div className={b({ open })}>
      <div className={b('header')}>
        <div className={b('title')}>{locale.filters}</div>
        <SVG
          svgProps={{ svg: !open ? plusIcon : minusIcon }}
          alt={locale.toggle ?? 'toggle'}
          className={b('toggle')}
          onClick={toggleFilters}
        />
      </div>

      {open && (
        <form className={b('body')} onSubmit={handleSubmit}>
          <div className={b('row', { group: true })}>
            <div className={b('col')}>
              <label className={b('label')} htmlFor="filters-id">
                {locale.id}
              </label>
              <Input
                id="filters-id"
                name="id"
                value={requestId}
                callBack={e => setRequestId(e.target.value)}
                placeholder={locale.id}
              />
            </div>

            <div className={b('col')}>
              <label className={b('label')} htmlFor="filters-username">
                {locale.username}
              </label>
              <Input
                id="filters-username"
                name="username"
                value={loginValue}
                callBack={e => setLoginValue(e.target.value)}
                placeholder={locale.username}
              />
            </div>
          </div>

          <div className={b('row')}>
            <div className={b('col')}>
              <label className={b('label')} htmlFor="filters-from">
                {locale.from}
              </label>
              <div className={b('date-input')}>
                <InputDate id="filters-from" value={fromDate} onChange={date => setFromDate(date)} showTimeSelect />
              </div>
            </div>

            <div className={b('col')}>
              <label className={b('label')} htmlFor="filters-to">
                {locale.to}
              </label>
              <div className={b('date-input')}>
                <InputDate id="filters-to" value={toDate} onChange={date => setToDate(date)} showTimeSelect />
              </div>
            </div>
          </div>

          <Button type="submit" className={b('submit')} text={locale.show} />
        </form>
      )}
    </div>
  );
};

export default FiltersPanel;
